import {getData} from "../api/get-data";

export const setAddCart = (itemId, resolveHandler) => {
  getData({
    [`set_cart`]: {
      [`item_id`]: itemId,
      [`action`]: `add`,
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
